<template>
  <b-card>
    <b-button variant="outline" @click="$router.push({ path: '/couriers-catalog', query: { country: countryId } })">
      <feather-icon icon="ChevronLeftIcon" size="30"/>
    </b-button>
    <img v-if="logoUrl" :src="logoUrl" class="logo_img" width="200" height="100" />
    <template v-if="!showTable">
      <b-row class="justify-content-center mt-4 pt-4">
        <b-col v-for="index in 4" :key="index" class="col-12 col-md-3 mt-1">
          <b-skeleton class="m-1 p-1" />
        </b-col>
      </b-row>
      <b-row>
        <b-col v-for="index in 4" :key="index" class="col-12 col-md-3 mt-1">
          <b-skeleton v-for="i in 3" :key="i" class="m-1 p-1" />
        </b-col>
      </b-row>
    </template>
    <TableDetailsCouriersCatalog v-if="showTable" :data="dataTable" />
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import TableDetailsCouriersCatalog from './TableDetailsCouriersCatalog.vue'
import BaseServices from '@/store/services/index'

export default {
  name: 'CouriersCatalog',
  components: { TableDetailsCouriersCatalog },
  data() {
    return {
      baseService: new BaseServices(this),
      courierData: null,
      showTable: false,
      dataTable: {},
      countryId: null,
      serviceIds: []
    }
  },
  computed: {
    ...mapGetters({
      courierServicesDetails: 'getCourierServicesDetails'
    }),
    logoUrl() {
      return this.courierData?.logotypes?.[0]?.url || null
    }
  },
  watch: {
    courierServicesDetails: 'setInitialData'
  },
  mounted() {
    this.loadCourierData()
  },
  methods: {
    async loadCourierData() {
      try {
        const { pathname } = window.location
        const segments = pathname.split('/').filter(Boolean)
        this.countryId = segments[2]
        this.serviceIds = segments[7]
        const carrierId = segments[5]
        const queryParams = { ['carriers[]']: carrierId }

        const services = [
          { name: 'getCourierCatalog', params: { country_id: this.countryId }, queryParams },
          { name: 'getServiceTypesByCountry', params: { country_id: this.countryId } }
        ]

        const response = await this.baseService.callMultipleServices(services, true)

        this.courierData = {
          ...response.getCourierCatalog.data[0],
          allCategories: response.getServiceTypesByCountry.data.map(el => ({ ...el, text: el.name }))
        }

        this.$store.dispatch('fetchService', {
          name: 'getCourierServicesDetails',
          params: { carrier_id: carrierId },
          queryParams: { 'category_ids[]': this.serviceIds },
          onError: this.handleError
        })
      } catch (err) {
        this.$newError('Error', `code: ${err}`)
        this.handleError()
      }
    },
    setInitialData() {
      this.dataTable = { ...this.courierData, ...this.courierServicesDetails }
      this.showTable = true
    },
    handleError() {
      this.showTable = true
    }
  }
}
</script>
